// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__grdQf","checkboxCol":"Table_checkboxCol__3Vzzv","emailCol":"Table_emailCol__2Tqft","actionCol":"Table_actionCol__3DPgI"};